"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _warning = _interopRequireDefault(require("warning"));

var _selectBase = _interopRequireDefault(require("../select-base"));

var _svgIcons = require("../internal/svg-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var NativeSelect = function NativeSelect(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      errorState = _ref.error,
      focused = _ref.focused,
      iconClassName = _ref.iconClassName,
      iconComponent = _ref.iconComponent,
      required = _ref.required,
      selectClassName = _ref.selectClassName,
      warning = _ref.warning,
      restOfSelectProps = _objectWithoutProperties(_ref, ["children", "className", "disabled", "error", "focused", "iconClassName", "iconComponent", "required", "selectClassName", "warning"]);

  var warningState = warning;
  /**
   * We cannot have both warning and error state be true for the input field
   * Default to using the error state instead
   */

  if (warningState && errorState) {
    (0, _warning.default)(!warningState && errorState, 'PDS::NATIVE-SELECT: warning and error cannot both be set to true; using error instead.');
    warningState = false;
  }

  var selectClasses = (0, _classnames.default)(selectClassName, {
    'pds-select-base': true,
    'pds-select-base--error': errorState,
    'pds-select-base--warning': warning && !errorState
  });
  var iconClassNames = (0, _classnames.default)(iconClassName, {
    'pds-dropdown-icon': true
  });
  var selectWrapperClassName = (0, _classnames.default)(className, {
    'pds-select-base-wrapper': true
  });
  return _react.default.createElement("div", {
    className: "pds-select-wrapper"
  }, _react.default.createElement(_selectBase.default, _extends({}, restOfSelectProps, {
    className: selectWrapperClassName,
    disabled: disabled,
    iconClassName: iconClassNames,
    iconComponent: iconComponent,
    required: required,
    selectClassName: selectClasses
  }), children));
};

NativeSelect.propTypes = {
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  disabled: _propTypes.bool,
  error: _propTypes.bool,
  focused: _propTypes.bool,
  iconClassName: _propTypes.string,
  iconComponent: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),
  required: _propTypes.bool,
  selectClassName: _propTypes.string,
  warning: _propTypes.bool
};
NativeSelect.defaultProps = {
  className: null,
  disabled: false,
  error: false,
  focused: false,
  iconClassName: null,
  iconComponent: _svgIcons.ArrowDropDown,
  required: false,
  selectClassName: null,
  warning: false
};
var _default = NativeSelect;
exports.default = _default;
